export default __webpack_public_path__ + "maps-examples-custom-callout-1200-ff20eb75622529849d81906a3f1957ce.png";